
import { defineComponent } from 'vue';
import { ContentBlock } from 'CoreHome';
import Provider from './Provider.vue';
import SearchEngineNavigation from '../Navigation/Navigation.vue';

export default defineComponent({
  props: {
    providers: {
      type: Array,
      required: true,
    },
  },
  components: {
    SearchEngineNavigation,
    ContentBlock,
    Provider,
  },
});
